import React from "react";
import cn from "classnames";

export default ({shrink, shortNav}) => (
  <div className={cn('navbar-item is-hidden-touch divider', shrink && !shortNav ? 'shrink-divider' : 'full-divider')}>
    |
  </div>
)